'use client'

import * as React from 'react'
import * as AvatarPrimitive from '@radix-ui/react-avatar'

import { cn } from '@/lib/utils'

function Avatar({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Root>) {
  return (
    <AvatarPrimitive.Root
      data-slot="avatar"
      className={cn(
        'relative flex size-8 shrink-0 overflow-hidden rounded-full',
        className,
      )}
      {...props}
    />
  )
}

function AvatarImage({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Image>) {
  return (
    <AvatarPrimitive.Image
      data-slot="avatar-image"
      className={cn('aspect-square size-full', className)}
      {...props}
    />
  )
}

function AvatarFallback({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Fallback>) {
  // If caller provided an explicit background utility (bg-...), avoid forcing the default `bg-muted`
  const hasBgUtility = typeof className === 'string' && /\bbg-/.test(className)
  const base = hasBgUtility ? 'flex size-full items-center justify-center rounded-full' : 'bg-muted flex size-full items-center justify-center rounded-full'

  return (
    <AvatarPrimitive.Fallback
      data-slot="avatar-fallback"
      className={cn(base, className)}
      {...props}
    />
  )
}

export { Avatar, AvatarImage, AvatarFallback }
